import { getGeneric } from "./main";

const exportVar = [getGeneric];
export default exportVar;
